import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, IMAGE_URL } from '../Component/Baseurl';
import { Link } from 'react-router-dom';
import Slider from "react-slick"; // Import Slick Slider
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'; // Import the arrow icons

function PopularCity() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/fetch-all-cities`);

        if (response.data.success) {
          const activeCities = response.data.cities.filter(city => city.city_status === 'active');
          setCities(activeCities);
        } else {
          setError("Failed to fetch cities");
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setError("Error fetching cities");
        setLoading(false);
      }
    };

    fetchCities();
  }, []);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p>Loading cities...</p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  if (cities.length === 0) {
    return <p>No active cities available.</p>;
  }

  // Custom Previous Arrow
  const PrevArrow = (props) => {
    const { className, onClick } = props;
    const arrowStyles = {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '30px',
      backgroundColor: '#000', // Arrow background color
      borderRadius: '50%', // Circular background
      padding: '1px',
      zIndex: 1, // Ensure the arrows are on top
      cursor: 'pointer',
    };

    return (
      <div
        className={className}
        onClick={onClick}
        style={{ ...arrowStyles, left: '10px' }} // Position on the left side
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </div>
    );
  };

  // Custom Next Arrow
  const NextArrow = (props) => {
    const { className, onClick } = props;
    const arrowStyles = {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '30px',
      backgroundColor: '#000', // Arrow background color
      borderRadius: '50%', // Circular background
      padding: '1px',
      zIndex: 1, // Ensure the arrows are on top
      cursor: 'pointer',
    };

    return (
      <div
        className={className}
        onClick={onClick}
        style={{ ...arrowStyles, right: '10px' }} // Position on the right side
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    );
  };

  // Slick slider settings
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 9, // Default for larger screens
    slidesToScroll: 2,
    nextArrow: <NextArrow />,  // Custom next arrow
    prevArrow: <PrevArrow />,  // Custom prev arrow
    responsive: [
      {
        breakpoint: 992, // Tablets and below
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, // Mobile landscape and below
        settings: {
          slidesToShow: 3, // Show 3 slides for mobile
        },
      },
      {
        breakpoint: 576, // Mobile portrait and below
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };
  
  return (
    <>
      <section className="pt-3">
        <div className="  bg-salt bdrnd py-3">
          <div className="row mb-3">
            <div className="col-8">
              <h2 className="text-start hedng">Popular By City</h2>
            </div>
            <div className="col-4 text-end">
              {/* <Link className="text-end viewall">View All</Link> */}
            </div>
          </div>

          <Slider {...settings}> {/* Slick Slider Component */}
            {cities.slice(0, 8).map((city) => (
              <div className="text-center mb-3" key={city.id}>
                <div className="image-container">
                  <img
                    src={`${IMAGE_URL}statecitycountry/${city.city_image}`}
                    alt={city.city_name}
                    className="img-fluid state-icn"
                  />
                </div>
                <div className="state-name">{city.city_name}</div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default PopularCity;
